import classNames from 'classnames';
import { InputHTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import type { StyleType } from '~types/common';

import { S } from './style';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  register?: UseFormRegisterReturn;
  label?: string;
  unit?: string;
  hasError?: boolean;
  errorMessage?: string;
  inputCss?: StyleType;
  fullWidth?: boolean;
}
function Input({
  label,
  register,
  unit,
  hasError,
  errorMessage,
  inputCss,
  fullWidth,
  ...props
}: Props) {
  return (
    <S.Wrapper fullWidth={fullWidth}>
      {label && <S.Label htmlFor={props.id}>{label}</S.Label>}
      <S.InputWrapper>
        <S.StyledInput
          {...register}
          {...props}
          inputCss={inputCss}
          className={classNames({ error: hasError }, props.className)}
        />
        {unit && (
          <S.Unit as='span' typography='midium150_B1' hasError={hasError}>
            {unit}
          </S.Unit>
        )}
      </S.InputWrapper>
      {hasError && (
        <S.Error typography='midium120_C1' as='div'>
          {errorMessage}
        </S.Error>
      )}
    </S.Wrapper>
  );
}

export default Input;
